import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";

const CardsContainer = styled(Box)(({ theme }) => ({
  paddingTop: theme.spacing(2),
  paddingBottom: theme.spacing(2),
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),

  border: `1px solid ${theme.palette.border.main}`,
  borderRadius: "10px",
  marginBottom: theme.spacing(2),

  backgroundColor: theme.palette.background.default,
}));
export default CardsContainer;
